import {
  type BaseModalFCProps,
  type ModalFC,
} from '@/components/modals/modalsManager';
import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/dialog';
import { electronApis } from '@/features/electron-api';

interface ForceUpdateModalProps extends BaseModalFCProps {
  version?: string;
}

export const ForceUpdateModal: ModalFC<ForceUpdateModalProps> = ({
  open,
  version,
}) => {
  const handleInstallUpdate = () => {
    electronApis.system.installUpdate();
  };

  return (
    <Dialog.Root open={open} onOpenChange={() => {}}>
      <Dialog.Content
        className="max-w-md"
        showCloseButton={false}
        onOpenAutoFocus={(e) => {
          const btn = document.getElementById('force-update-btn');
          if (btn) btn.focus();
          else e.preventDefault();
        }}
      >
        <Dialog.Header>
          <Dialog.Title className="text-lg">Update Required</Dialog.Title>
          <Dialog.Description
            id="force-update-desc"
            className="text-foreground-subtle"
          >
            A new version{version ? ` (v${version})` : ''} is available and
            ready to install. Please update to continue using Littlebird.
            <br />
            The update will restart the application automatically.
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer className="gap-3 pt-4">
          <Button id="force-update-btn" onClick={handleInstallUpdate} size="lg">
            Install & Restart
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
